
// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
}
